import { render, staticRenderFns } from "./TagManagement.vue?vue&type=template&id=5503d32a&"
import script from "./TagManagement.vue?vue&type=script&lang=js&"
export * from "./TagManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports